import { css } from "@emotion/react";
import { useState } from "react";

type Section = {
  title: string;
  id: string;
};

const sections: Section[] = [
  {
    title: "8/5 Sat 18:30",
    id: "cast-schedule-0805",
  },
  {
    title: "8/6 Sun 12:30",
    id: "cast-schedule-0806-1230",
  },
  {
    title: "8/6 Sun 18:00",
    id: "cast-schedule-0806-1800",
  },
];

// HamburgerMenuコンポーネントのスタイル
const styles = {
  menuContainer: css`
    position: fixed;
    top: 0;
    right: 0;
    width: 60%;
    height: 100vh;
    max-width: 300px;
    max-height: 250px;
    background-color: rgba(248, 204, 197);
    transition: transform 0.3s ease-in-out;
    transform: translateX(100%);
    z-index: 1;
  `,

  conatinerOpen: css`
    transform: translateX(0) !important;
  `,

  menuItems: css`
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      padding: 10px;
      border-bottom: 1px solid #ccc;

      a {
        text-decoration: none;
        color: #333;
        font-size: 16px;

        &:hover {
          color: #ff0000;
        }
      }
    }
  `,

  hamburgerIcon: css`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 20px;
  `,
};

const HumburgerMenu: React.FC = ({}) => {
  const [isOpen, setIsOpen] = useState(false);

  /**
   * クリック時対象のセクションにスクロールする
   */
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const onClickItem = (id: string) => {
    scrollToSection(id);
    setIsOpen(false);
  };

  return (
    <>
      <img
        onClick={() => setIsOpen(true)}
        src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/humburger.png"}
        alt="humburger-menu"
        css={humburgerStyle}
      />
      <div css={[isOpen && styles.conatinerOpen, styles.menuContainer]}>
        <img
          onClick={() => setIsOpen(false)}
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/close-button.png"}
          alt=""
          css={closeButtonStyle}
        />
        <div css={menuContainerStyle}>
          {sections.map((section) => (
            <div onClick={() => onClickItem(section.id)} key={section.id}>
              <a css={linkStyle}>{section.title}</a>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const primaryColor = "#DD6B74";

const humburgerStyle = css`
  z-index: 1;
  position: fixed;
  top: 0;
  right: 0;
  width: 50px;
  height: 50px;
`;

const closeButtonStyle = css`
  position: absolute;
  top: 10px;
  left: 10px;
  width: 30px;
  height: 30px;
`;

const menuContainerStyle = css`
  padding: 50px 20px 30px;
  text-align: right;
`;

const linkStyle = css`
  text-underline-offset: 5px;
  line-height: 30px;
  color: ${primaryColor};
  border: none;
  font-weight: bold;
`;

export default HumburgerMenu;
